import React, { useState, useEffect } from 'react';
import { Button, Alert, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useLocation} from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import ProductList from '../components/ProductList.tsx';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';
import GiftModal from '../components/GiftModal.tsx';



// Load the publishable key from your environment

const CanvaPurchase = () => {
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [error, setError] = useState(null);
  
  const { canvaAuthenticated } = useCanvaAuth();
const location = useLocation();
 const isUpgrade = location.pathname.includes("upgrade");
 
 const [showGiftModal, setShowGiftModal] = useState(false);

useEffect(() => {
  if (canvaAuthenticated?.userProfile?.gift) {
    setShowGiftModal(true);
  }
}, [canvaAuthenticated]);


  

  return (
    <>
      <Helmet>
        <title>AI Music by Muzaic</title>
      </Helmet>
      
      <h2 className="text-white text-center product-list-title">{isUpgrade ? canvaAuthenticated.env.strings['app-product-list-title-upgrade'] : canvaAuthenticated.env.strings['app-product-list-title-manage']}</h2>
      <ProductList />
      <div className="text-white text-center mt-5">
      © Muzaic 2025 <br></br><a className="text-decoration-none" href="https://muzaic.ai/terms-of-use" target="_blank"> {canvaAuthenticated.env.strings['app-link-terms-of-use'] || 'app-link-terms-of-use'}</a>
      </div>
      
      <GiftModal show={showGiftModal} onClose={() => setShowGiftModal(false)} />

      
    </>
  );
};

export default CanvaPurchase;
